import { DeleteOutlined, KeyOutlined, UnlockOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import { DisableIcon } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import React, { useState } from 'react';
import { DeleteDeviceModal, GrantPermissionsToDeviceModal, ManageDeviceGroupsModal } from 'zComponents/molecules';
import { Button, Divider, Dropdown, Flex, Tooltip } from 'zui/Antd';

const ManageDeviceDropdown = ({ deviceID = {}, isTransparent = false }) => {
	// ✅ Hooks
	const {
		token: { colorBgContainer, boxShadow, borderRadiusLG, paddingSM, colorPrimaryText, fontWeightStrong }
	} = theme.useToken();

	// ✅ Permissions
	const canManagePermissions = useManagePermittedRoles('aCPermissionManagement');
	const canUpdateGroup = useManagePermittedRoles('updateGroup');
	const canRevokeDeviceAccess = useManagePermittedRoles('revokeDeviceAccess');
	const canDisableDevice = useManagePermittedRoles('disableDevice');
	const canDeleteDevice = useManagePermittedRoles('deleteDevice');
	const permissionDeniedMessage = "You don't have permission to perform this action.";

	// ✅ Local State
	const [openDropdown, setOpenDropdown] = useState(false);

	const items = [
		{
			key: 'managePermissions',
			label: (
				<GrantPermissionsToDeviceModal deviceID={deviceID}>
					<Button
						type='text'
						icon={<KeyOutlined color='currentColor' />}
						block
						disabled={!canManagePermissions}
						style={{
							justifyContent: 'flex-start',
							fontWeight: fontWeightStrong
						}}
					>
						Manage Permissions
					</Button>
				</GrantPermissionsToDeviceModal>
			)
		},
		{
			key: 'manageDeviceGroups',
			label: (
				<ManageDeviceGroupsModal deviceID={deviceID}>
					<Button
						type='text'
						icon={<UsergroupAddOutlined color='currentColor' />}
						block
						disabled={!canUpdateGroup}
						style={{
							justifyContent: 'flex-start',
							fontWeight: fontWeightStrong
						}}
					>
						Manage Device Groups
					</Button>
				</ManageDeviceGroupsModal>
			)
		},
		{
			key: 'divider',
			label: <Divider style={{ margin: 0 }} />
		},
		{
			key: 'revokeAccess',
			label: (
				<Tooltip
					title={!canRevokeDeviceAccess ? permissionDeniedMessage : 'Currently working on it'}
					placement='top'
				>
					<Button
						type='text'
						icon={<UnlockOutlined color='currentColor' />}
						style={{
							justifyContent: 'flex-start',
							fontWeight: fontWeightStrong
						}}
						block
						disabled={!canRevokeDeviceAccess || true}
					>
						Revoke All Access
					</Button>
				</Tooltip>
			)
		},
		{
			key: 'disableDevice',
			label: (
				<Tooltip
					title={!canDisableDevice ? permissionDeniedMessage : 'Currently working on it'}
					placement='top'
				>
					<Button
						type='text'
						icon={<DisableIcon color='currentColor' width={16} height={16} />}
						disabled={!canDisableDevice || true}
						block
						style={{
							justifyContent: 'flex-start',
							fontWeight: fontWeightStrong
						}}
					>
						Disable Device
					</Button>
				</Tooltip>
			)
		},
		{
			key: 'deleteDevice',
			label: (
				<DeleteDeviceModal deviceID={deviceID}>
					<Button
						type='text'
						icon={<DeleteOutlined color='currentColor' />}
						danger
						disabled={!canDeleteDevice || true}
						style={{
							justifyContent: 'flex-start',
							fontWeight: fontWeightStrong
						}}
						block
					>
						Delete Device
					</Button>
				</DeleteDeviceModal>
			)
		}
	];

	return (
		<Dropdown
			openClassName='dropdown-open'
			trigger={['click']}
			placement='bottomRight'
			open={openDropdown}
			onOpenChange={(visible) => setOpenDropdown(visible)}
			dropdownRender={() => (
				<Flex
					style={{
						backgroundColor: colorBgContainer,
						borderRadius: borderRadiusLG,
						width: 240,
						boxShadow: boxShadow,
						padding: paddingSM
					}}
					vertical
					gap={paddingSM}
				>
					{items.map((item) => (
						<div key={item.key} onClick={() => setOpenDropdown(false)}>
							{item.label}
						</div>
					))}
				</Flex>
			)}
		>
			<Button type={isTransparent ? 'text' : 'primary'} style={{ color: isTransparent && colorPrimaryText }}>
				{isTransparent ? 'View' : 'Manage'} Device
			</Button>
		</Dropdown>
	);
};

export default ManageDeviceDropdown;
